import { ChartSvg, ChartTitle } from "@/components/tool-kit/charts/chart-svg";
import { px } from "@/components/tool-kit/charts/marks";
import type { TitleBlock } from "@/lib/tool-kit/charts/layout";
import type { PlacedWord } from "@/lib/tool-kit/diagrams/word-cloud";

/*
 * A word cloud from `layoutCloud`. Each word is centred on its box; a vertical word is
 * the same text turned −90° about that centre, so it reads bottom to top. Weight and
 * family are attributes on the root and the text, so the exported file matches what the
 * canvas measured.
 */

export function WordCloudSvg({
  id,
  width,
  height,
  title,
  words,
  colors,
  label,
  description,
}: {
  id: string;
  width: number;
  height: number;
  title: TitleBlock | null;
  words: readonly PlacedWord[];
  /** One colour per word passed to the layout (indexed by `PlacedWord.index`). */
  colors: readonly string[];
  label: string;
  description: string;
}) {
  return (
    <ChartSvg
      description={description}
      height={height}
      id={id}
      label={label}
      width={width}
    >
      <ChartTitle title={title} />
      {words.map((word) => {
        const x = px(word.x);
        const y = px(word.y);
        return (
          <text
            fill={colors[word.index]}
            fontSize={px(word.size)}
            fontWeight="bold"
            key={`${word.index}-${word.text}`}
            textAnchor="middle"
            transform={word.vertical ? `rotate(-90 ${x} ${y})` : undefined}
            x={x}
            y={px(word.y + word.baseline)}
          >
            {word.text}
          </text>
        );
      })}
    </ChartSvg>
  );
}
